module.exports = __webpack_public_path__ + "img/contact_ma.8a62147d.png";